export enum PublishStatus {
  Success = "success",
  Error = "error",
  Confirmation = "confirmation",
  StoriesLimit = "stories-limit",
  /** Publish refused: the story uses variables above the account's plan
   * (the "Upgrade to publish" dialog has been opened). */
  PlanRequired = "plan-required",
}
